import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";
import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { differenceInMinutes, parseISO } from "date-fns";

export function useWorkerLeftEarlyFeatureFlag(shiftEndTime?: string) {
  const featureFlag = useCbhFlag(CbhFeatureFlag.WORKER_LEFT_EARLY, {
    defaultValue: {
      enabled: true,
      replacementFlow: { enabled: true },
      canMarkWLEForVerifiedShifts: true,
      canMarkWLEForCancelledShifts: true,
      minutesBeforeShiftEndForAllowingReplacement: 90,
    },
  });

  // Check if replacement can be requested based on shift end time
  const canRequestReplacement = () => {
    if (!featureFlag.replacementFlow.enabled || !shiftEndTime) {
      return false;
    }

    const now = new Date();
    const shiftEnd = parseISO(shiftEndTime);
    const minutesUntilShiftEnd = differenceInMinutes(shiftEnd, now);

    return minutesUntilShiftEnd >= featureFlag.minutesBeforeShiftEndForAllowingReplacement;
  };

  return {
    ...featureFlag,
    canRequestReplacement: canRequestReplacement(),
    isEnabled: featureFlag.enabled,
  };
}
